import theme from 'tailwindcss/defaultTheme';

export default Object.keys(theme.spacing).reduce(
  (acc, key) => {
    const castedKey = key as keyof typeof theme.spacing;

    if (theme.spacing[castedKey].includes('px')) {
      acc[castedKey] = theme.spacing[castedKey];
      return acc;
    }

    const rem = theme.spacing[castedKey];
    const spacingValue = rem.replace('rem', '');

    acc[castedKey] = `${parseFloat(spacingValue) * 16}px`;
    return acc;
  },
  {} as Record<
    | '0'
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | '10'
    | '11'
    | '12'
    | '14'
    | '16'
    | '20'
    | '24'
    | '28'
    | '32'
    | '36'
    | '40'
    | '44'
    | '48'
    | '52'
    | '56'
    | '60'
    | '64'
    | '72'
    | '80'
    | '96'
    | 'px'
    | '0.5'
    | '1.5'
    | '2.5'
    | '3.5',
    string
  >
);
